// This file was automatically generated
// Don't edit this file manually

// Required version of harrenhal
module.exports.HARRENHAL_VER = "0.1.5";

// Link to Harrenhal DMG file
module.exports.HARRENHAL_LINK = "harrenhal-0.1.5.pkg";
